import downloadByLink from '@/utils/download-by-link';

const offerTemplate = {
  data() {
    return {
      templateIsDownloading: false,
    };
  },
  computed: {
    fileName() {
      return this.$t('Excel template');
    },
  },
  methods: {
    async loadTemplate(incomingTenderId, fileName, currency = null) {
      this.templateIsDownloading = true;
      let link = `/incoming_tenders/offers/${incomingTenderId}/xlsx_template/`;
      if (currency !== null) {
        link += `?currency=${currency}`;
      }
      await downloadByLink({ link, fileName });
      this.templateIsDownloading = false;
    },
  },
};

export default offerTemplate;
